export const AddToPromotion = "c2573a7c50b7abcecef0917bc93dc3a8e2112d8062425edb6f3ae188297f2254";